<template>
  <Txt class="mt-4 flex items-center gap-2 text-base font-medium">{{ $t('Company.Licenses') }}</Txt>
  <p class="text-sm text-gray-600">{{ $t('Company.LicensesDescription')}}</p>

  <CGBanner
    :title="$t('Company.CGServices')"
    :subtitle="$t('Company.CGServicesDescription')"
    variant="indigo"
  >
    <template #icon>
      <font-awesome-icon :icon="['fas','box']" class="text-indigo-800 w-5 h-5" />
    </template>
  </CGBanner>

  <div v-if="activeServices" class="grid grid-cols-2 md:grid-cols-3 gap-3 mt-6">
    <div class="text-center p-3 bg-green-50 rounded-lg border border-green-200">
      <div class="text-lg font-bold text-green-600">{{ activeServices }}</div>
      <div class="text-xs text-green-800">{{ $t('Company.ActiveServices', parseInt(activeServices, 10)) }}</div>
    </div>
    <div class="text-center p-3 bg-blue-50 rounded-lg border border-blue-200">
      <div class="text-lg font-bold text-blue-600">{{ totalLicenses }}</div>
      <div class="text-xs text-blue-800">{{ $t('Company.TotalLicenses', parseInt(totalLicenses)) }}</div>
    </div>
    <!-- <div class="text-center p-3 bg-purple-50 rounded-lg border border-purple-200">
      <div class="text-lg font-bold text-purple-600">{{ activeServices }}</div>
      <div class="text-xs text-purple-800">{{ $t('Company.Package', parseInt(activeServices, 10)) }}</div>
    </div> -->
    <div class="text-center p-3 bg-gray-50 rounded-lg border border-gray-200">
      <div class="text-lg font-bold text-gray-600">{{ 5 - activeServices }}</div>
      <div class="text-xs text-gray-800">{{ $t('Company.Available') }}</div>
    </div>
  </div>

  <!-- Licenses -->
  <div class="space-y-6 pt-10 pb-6">
    <h3 class="text-lg font-semibold flex items-center space-x-2">
      <font-awesome-icon :icon="['fas','box']" class="text-blue-800 w-5 h-5" />
      <span class="pt-1">{{ $t('Company.ConfigureServices') }}</span>
    </h3>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <LicenseCard
        v-for="(service, i) in draftCompany.services"
        :id="service.id"
        :key="i"
        v-model="service.enabled"
        :title="LicenseType[service.id]"
        :subtitle="$t('Company.' + service.id + 'Description')"
        :variant="service.variant"
        v-bind="service"
        @update:quantity="service.quantity = $event"
        @update:start_date="service.start_date = $event"
        @update:license_length="service.license_length = $event"
      >
        <template #icon>
          <font-awesome-icon :icon="['fas', service.icon]" class="text-white w-8 h-8" />
        </template>
      </LicenseCard>
    </div>
  </div>

  <div v-if="activeServices" class="rounded border p-6 bg-green-50 border-green-200">
    <h4 class="font-semibold text-green-900 mb-6 flex items-center space-x-2">
      <font-awesome-icon :icon="['fas','circle-check']" class="text-green-800 w-5 h-5" />
      <span>{{ $t('Company.ActiveServicesRecap') }}</span>
    </h4>
    <div class="space-y-4">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <ActiveServiceCard v-for="service in draftCompany.services.filter(s => s.enabled)" :key="service.id" v-bind="service" />
      </div>
    </div>
  </div>

  <CGBanner
    v-else
    :title="$t('Company.NoActiveServices')"
    :subtitle="$t('Company.NoActiveServicesDescription')"
    variant="amber"
  >
    <template #icon>
      <Icon name="info" size="22" class="text-amber-600" />
    </template>
  </CGBanner>

</template>

<script>
import { defineComponent } from 'vue';
import { AuthenticationType, LicenseType } from '@/common/constants';

export default defineComponent({
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      LicenseType,
      AuthenticationType,
      draftCompany: { ...this.company }
    };
  },
  watch: {
    company: {
      handler(newVal) {
        this.draftCompany = { ...newVal };
      },
      deep: true
    }
  },
  computed: {
    activeServices() {
      return (this.draftCompany.services.filter(service => service.enabled) || []).length;
    },
    totalLicenses() {
      return this.draftCompany.services.reduce((total, service) => {
        return total + (service.enabled ? parseInt(service.quantity, 10) : 0);
      }, 0);
    },
  }
});
</script>